import API from "../axiosConfig";
import { BACKEND_URL } from "../../constants"; // Import BACKEND_URL

export const getVehicles = async () => {
  try {
    const response = await API.get("/vehicles");
    return response.data;
  } catch (error) {
    console.error("Error fetching vehicles:", error);
    throw error;
  }
};

export const getVehicleSearch = async (params) => {
  try {
    const response = await API.get("/vehicles-search", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching vehicles:", error);
    throw error;
  }
};

export const getVehicleById = async (id) => {
  try {
    const response = await API.get(`/vehicles/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getVehiclesByClientId = async (clientId) => {
  try {
    const response = await API.get(`/vehicles/client/${clientId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching vehicles for client:", error);
    throw error;
  }
};

export const createVehicle = async (formData) => {
  try {
    const response = await API.post("/vehicles", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating vehicle:", error);
    throw error;
  }
};

export const updateVehicle = async (vehicleId, vehicleData) => {
  try {
    const response = await API.put(`/vehicles/${vehicleId}`, vehicleData);
    return response.data;
  } catch (error) {
    console.error("Error updating vehicle:", error);
    throw error;
  }
};

export const deleteVehicle = async (vehicleId) => {
  try {
    const response = await API.delete(`/vehicles/${vehicleId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting vehicle:", error);
    throw error;
  }
};

export const vehiclesNotAssignedToClient = async (params = {}) => {
  try {
    const response = await API.get(`/vehicles/not-assigned`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching vehicles not assigned to client:", error);
    throw error;
  }
};

export const assignVehicleToClient = async (clientId, vehicleId) => {
  try {
    const response = await API.post(`/vehicles/assign/${vehicleId}`, {
      owner_id: clientId,
    });
    return response.data;
  } catch (error) {
    console.error("Error assigning vehicle to client:", error);
    throw error;
  }
};

export const unassignVehicleFromClient = async (vehicleId) => {
  try {
    const response = await API.post(`/vehicles/unassign/${vehicleId}`);
    return response.data;
  } catch (error) {
    console.error("Error unassigning vehicle from client:", error);
    throw error;
  }
};

// vehicles/not-subscribed-with-blacklist-status
export const vehicleWithBlacklistStatus = async (clientId) => {
  try {
    const response = await API.get(`/vehicles/not-subscribed/${clientId}`);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching vehicles with blacklist status:",
      error
    );
    throw error;
  }
};

export const addVehicleFiles = async (vehicleId, formData) => {
  try {
    const response = await API.post(`/vehicles/${vehicleId}/documents`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error adding files to vehicle:", error);
    throw error;
  }
};

export const deleteVehicleFile = async (vehicleId, filePath) => {
  try {
    const response = await API.put(`/vehicles/${vehicleId}/documents`, {
      file_to_delete: filePath, // Send the relative path stored in the DB
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting file from vehicle:", error);
    throw error;
  }
};

export const getVehicleDocumentUrl = (filePath) => {
  return `${BACKEND_URL}/${filePath}`;
};

export const changeSubscriptionVehicle = async (subscriptionId, vehicleId, reason) => {
  try {
    const response = await API.put(`/subscriptions/${subscriptionId}/change-vehicle`, {
      vehicle_id: vehicleId,
      reason: reason,
    });
    return response.data;
  } catch (error) {
    console.error("Error changing subscription vehicle:", error);
    throw error;
  }
};
